module.exports = __webpack_public_path__ + "img/32-heat-cramping.436a82ac.svg";